export const CARD_ART_WIDTH = "128px";
export const CARD_ART_HEIGHT = "81px";
